import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Purple Style Labs',
        projectDesc: 'This project aims to build an Luxury cloths selling website. It is an E-commerce website which is fully responsive.',
        tags: ['React', 'SCSS', 'JavaScript'],
        code: '',
        demo: 'https://purplestylelabs.com/',
        image: one
    },
    {
        id: 2,
        projectName: 'Cycle On Rent',
        projectDesc: 'This project aims to build an Cycle Rent system that consolidates all information of a Products and also users can rent these products',
        tags: ['React', 'CSS', 'Material Ui'],
        code: '',
        demo: 'https://cycleonrent.com/',
        image: two
    },
    {
        id: 3,
        projectName: 'Fab Agriculture',
        projectDesc: 'This project is a Agriculture Products Selling that allows users to purchase agriculture products.',
        tags: ['React', 'Django', 'Tailwind CSS'],
        code: '',
        demo: 'https://agriculture.datavivservers.in/',
        image: three
    },
    {
        id: 4,
        projectName: 'ELSC Conclave',
        projectDesc: 'This website is for Express Logistics & Supply Chain Conclave',
        tags: ['React', 'CSS', 'Material Ui'],
        code: '',
        demo: 'https://www.elscconclave.com/',
        image: four
    },
    {
        id: 5,
        projectName: 'Customer Fest Show',
        projectDesc: 'This project is for Customer Fest Show .',
        tags: ['Wordpress', 'Figma'],
        code: '',
        demo: 'http://www.thecustomerfest.com/',
        image: five
    },
    {
        id: 6,
        projectName: 'SS Shopsey App',
        projectDesc: 'This Project is Shopping E-commerce application',
        tags: ['React js', 'Bootstrap', 'Node js'],
        code: '',
        demo: '',
        image: six
    },
    {
        id: 7,
        projectName: 'Camerax',
        projectDesc: 'Camerax is a AI based project which is based on Camera captured data.',
        tags: ['AI', 'Django', 'React'],
        code: '',
        demo: '',
        image: seven
    },
   
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/